import {applyMiddleware, createStore} from 'redux';

import {createLogger} from 'redux-logger';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import reducers from './common/reducer/reducers';

const logger = createLogger({
    predicate: () => false // set to true for logging
});

const middleware = applyMiddleware(promise(), thunk, logger);

export var store = createStore(reducers, middleware);
